<template>

    <Grid v-if="isGrid">

        <Column :span="[ 2, 6 ]">

            <Picture :image="data.assets[0]" cover height="auto" width="auto" maxWidth="auto"/>

        </Column>

    </Grid>

    <div v-else class="w-screen">

        <Picture :image="data.assets[0]" cover width="100%" maxWidth="auto" height="auto" maxHeight="100%"/>

    </div>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import Grid from '../Grid/Grid.vue'
    import Column from '../Grid/Column.vue'
    import Picture from '../Picture.vue'

    export default defineComponent({
        name: 'BlogImage',
        components: {
            Grid,
            Column,
            Picture
        },
        props: {
            data: { type: Object, required: true }
        },
        setup(props) {

            return {
                isGrid: props.data?.style?.value === 'grid',
                isFull: props.data?.style?.value === 'full'
            }

        }
    })

</script>

<style lang="scss">

    @include component(blog-image) {

        max-width: 1540px;

        @screen lg {

            width: calc(100% - ((2.5rem + 15px) * 2));

        }

        @screen sm {

            width: calc(100% - (1rem * 2));

        }

    }

</style>
